import gql from 'graphql-tag';

export const RUN_SEARCH_QUERY = gql`
  query RunSearch(
    $entityName: String!
    $projectName: String!
    $filters: JSONString!
    $first: Int
  ) {
    project(entityName: $entityName, name: $projectName) {
      id
      runs(first: $first, order: "-createdAt", filters: $filters) {
        edges {
          node {
            id
            name
            displayName
          }
        }
      }
    }
  }`;
